<template>
  <qx-card-form title="已绑定司机" v-show="showComponent">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <span slot="applyDriverUserId" slot-scope="prop">
        <el-radio-group v-model="prop.form.applyDriverUserId">
          <el-radio
            :label="item.driverId"
            class="radio-custom"
            v-for="(item, index) in driverList"
            :key="index"
          >
            <el-form :inline="true">
              <el-form-item label="司机姓名" class="radio-custom-form">
                <el-input class="inputBox" :value="item.driverName" disabled></el-input>
              </el-form-item>
              <el-form-item label="司机电话" class="radio-custom-form">
                <el-input class="inputBox" :value="item.mobilePhone" disabled></el-input>
              </el-form-item>
            </el-form>
          </el-radio>
        </el-radio-group>
      </span>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
export default {
  data () {
    return {
      showComponent: false,
      driverList: [],
      baseForm: {
        inline: true,
        form: [
          {
            label: '司机姓名',
            value: 'applyDriverUserId',
            slot: true,
            allCustom: true,
          },
        ],
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // formData = {};
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      const res = await this.handleSubData();
      return res;
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      this.resetBaseForm();
      this.$refs.baseForm.setVal(data);
    },
    resetBaseForm () {
      this.showComponent = false;
    },
    formChange (vehicleInfo) {
      this.resetBaseForm();
      if (!this.$route.query.id) {
        if (vehicleInfo.driverList && vehicleInfo.driverList.length) {
          // 如果有已绑定司机，显示所有已绑定司机，单选，选中的提交司机的id字段 applyDriverUserId
          this.driverList = vehicleInfo.driverList;
          this.showComponent = true;
        } else {
          this.driverList = [];
          this.showComponent = false;
        }
      }
    },
    receivedData (vehicleInfo) {
      if (vehicleInfo) {
        this.formChange(vehicleInfo);
      } else {
        this.showComponent = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.radio-custom {
  display: flex;
  align-items: center;
  margin-left: 50px;
  .radio-custom-form {
    margin-bottom: 0;
  }
}
</style>
